import Head from "next/head"
import RenderBlocks from "@lib/renderBlocks"
import { generateFaqSchema } from "@lib/utils"
import { documentToPlainTextString } from "@contentful/rich-text-plain-text-renderer"

import Layout from "../../layout"
import RecommendedReading from "@components/recommended-reading"

// ---------------------------------------------------------

const FlexiblePage = ({
  data,
  recommended,
  children,
  preview,
  pageTitle,
  featuredImage,
  excerpt
}) => {
  const meta = {
    "og:title": pageTitle ? pageTitle : data?.title,
    title: pageTitle ? pageTitle : data?.title,
    "og:image": featuredImage?.url || data?.featuredImage?.url,
    description: excerpt ? excerpt : data?.excerpt,
    "og:description": excerpt ? excerpt : data?.excerpt,
    robots: data?.isPrivate ? "noindex" : "index"
  }

  // Extract all Accordion items from Grids to build FAQ schema
  const accordionQuestions =
    data?.modulesCollection?.items
      ?.filter((item) => item.__typename === "Accordion")
      ?.flatMap((accordion) =>
        (accordion.accordionItemsCollection?.items || []).map((item) => ({
          ...item,
          answer: documentToPlainTextString(item.content.json)
        }))
      ) || []

  const faqSchema = accordionQuestions.length > 0 ? generateFaqSchema(accordionQuestions) : null

  // ---------------------------------------------------------

  return (
    <Layout
      preview={preview}
      customMeta={meta}
      navSettings={{
        hideNavLeft: data?.navSettings?.includes("Hide left nav"),
        hideNavRight: data?.navSettings?.includes("Hide right nav"),
        customCta: {
          label: data?.demoLabel,
          url: data?.demoUrl
        }
      }}
    >
      {faqSchema && (
        <Head>
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
          />
        </Head>
      )}
      {data?.modulesCollection && RenderBlocks(data.modulesCollection.items)}
      {children}
      <RecommendedReading recommended={recommended} />
    </Layout>
  )
}

export default FlexiblePage
